<mat-card style="margin-bottom: 1em;">
    <h2>Total de propuestas</h2>
    <label style="padding-left: 0.5em;">{{totalProposals}}</label>
</mat-card>

